/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./all-platform-view.vue?vue&type=template&id=700f3224&scoped=true"
import script from "./all-platform-view.vue?vue&type=script&lang=js"
export * from "./all-platform-view.vue?vue&type=script&lang=js"
import style0 from "./all-platform-view.vue?vue&type=style&index=0&id=700f3224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700f3224",
  null
  
)

export default component.exports